import { ComponentType, lazy, LazyExoticComponent } from 'react';
import { CoreComponentListKey, CoreComponentListType, CoreComponentTypes } from './types.core';

export interface RegistryComponents {
    [key: string]: any;
}

export class ReactCoreRegistry {
    list: RegistryComponents = {};
    listLazy: RegistryComponents = {};

    public getComponent(name: string): any {
        if (!this.list[name]) {
            return;
        }
        return this.list[name];
    }

    public registerLazyComponent(name: string, promise: LazyExoticComponent<ComponentType<any>>) {
        this.list[name] = promise;
    }

    // Register all components of a lib
    // with webpack the libname must be specified explicitly
    // import('jamespot-react-components') => ok
    // const lib = 'jamespot-react-components'; import(lib); => KO
    // Error : Critical dependency: the request of a dependency is an expression
    // that's why we must use an importPromise here

    public registerLib(componentList: Partial<CoreComponentListType>, importPromise: any) {
        if (componentList) {
            Object.entries(componentList).forEach(([name, component]) => {
                this.registerLazyComponent(
                    name,
                    lazy(() =>
                        importPromise.then((module: any) => {
                            return {
                                default: module[component],
                            };
                        }),
                    ),
                );
            });
        }
    }

    public getLazyComponent<T extends CoreComponentListKey>(name: T): CoreComponentTypes[CoreComponentListType[T]] {
        if (!this.list[name]) {
            if (process.env.NODE_ENV !== 'production')
                console.error(`/!\\ COMPONENT ${name} NOT EXPORTED IN THE CORE BUNDLE /!\\`);
            return this.list['empty'];
        }
        return this.list[name];
    }
}
